import Axios from "axios";
import { toast } from "react-toastify";
import { api_url } from "../config";

const dataService = {
  getMany: (
    urls,
    successCallback = () => {},
    beforeCallBack = () => {},
    anyCallBack = () => {}
  ) => {
    beforeCallBack();
    var allPromises = [];
    urls.forEach((url) => {
      switch (url.type) {
        case "GET":
          allPromises.push(
            new Promise((resolve, reject) => {
              dataService.get(
                url.path,
                (datas) => resolve({ name: url.name, datas }),
                reject,
                () => {}
              );
            })
          );
          break;
        case "POST":
          allPromises.push(
            new Promise((resolve, reject) => {
              dataService.post(
                url.path,
                url.postData,
                (datas) => resolve({ name: url.name, datas }),
                reject,
                () => {}
              );
            })
          );
          break;
      }
    });
    var results = {};
    Promise.all(allPromises)
      .then((values) => {
        values.forEach((val) => {
          results[val.name] = val.datas;
        });
        successCallback(results);
      })
      .catch((err) => {})
      .then(anyCallBack);
  },
  get: (url, successCallback = () => {}, errorCallback = () => {}, anyCallBack = () => {}) => {
    Axios.get(api_url + url)
      .then((res) => successCallback(res.data))
      .catch((err) => {
        dataService.errorDisplay(err, errorCallback);
      })
      .then(anyCallBack);
  },
  post: (
    url,
    postData,
    successCallback = () => {},
    errorCallback = () => {},
    anyCallBack = () => {}
  ) => {
    Axios.post(api_url + url, postData)
      .then((res) => successCallback(res.data))
      .catch((err) => {
        dataService.errorDisplay(err, errorCallback);
      })
      .then(anyCallBack);
  },
  patch: (
    url,
    postData = {},
    successCallback = () => {},
    errorCallback = () => {},
    anyCallBack = () => {}
  ) => {
    Axios.patch(api_url + url, postData)
      .then((res) => successCallback(res.data))
      .catch((err) => {
        dataService.errorDisplay(err, errorCallback);
      })
      .then(anyCallBack);
  },
  remove: (
    url,
    deleteData = {},
    successCallback = () => {},
    errorCallback = () => {},
    anyCallBack = () => {}
  ) => {
    if (!window.confirm("Supprimer cette entrée ?")) {
      anyCallBack();
      return false;
    }
    Axios.delete(api_url + url, deleteData)
      .then((res) => successCallback(res.data))
      .catch((err) => {
        dataService.errorDisplay(err, errorCallback);
      })
      .then(anyCallBack);
  },
  errorDisplay: (err, errorCallback) => {
    if (
      err.response &&
      err.response.data &&
      Object.keys(err.response.data).length > 0 &&
      typeof err.response.data === "object"
    ) {
      Object.values(err.response.data).forEach((err) => toast.error(err));
      errorCallback(err.response.data);
    } else {
      if (err.response?.status == "404") {
        toast.warning(`La route n'existe pas : ${err.response.config?.url}`);
      }
      errorCallback({ other: "Une erreur est survenue" });
    }
  },
};

export default dataService;
